<template>
  <div class="game">
    <div id="game4"></div>

    <van-tabs color="#0a89ee" v-model="useType">
      <van-tab :title="'使用金豆：' + game_money"></van-tab>
      <van-tab :title="'使用优惠券：' + free_play_times"></van-tab>
    </van-tabs>

    <van-notice-bar wrapable left-icon="info-o">
      <span class="alert-link">100金豆</span> 或
      <span class="alert-link">1张优惠券</span> 抽奖1次 <br />
      每天抽奖 <span class="alert-link">10 次</span>，今天已抽奖
      <span class="alert-link">{{ play_times_today }} 次</span><br />
      在此活动中Apple不是赞助者，也没有以任何形式参与活动。
    </van-notice-bar>

    <van-divider>抽奖记录</van-divider>
    <van-cell-group>
      <van-cell
        v-for="item in game_log.data"
        v-bind:key="item.id"
        :title="item.award"
        :value="item.create_time"
        :label="(item.type == 1 ? '金豆' : '优惠券') + '抽奖'"
      />
    </van-cell-group>
  </div>
</template>
<script>
import { VUE_GAME_ASSETS_URL } from "@utils";
import Vue from "vue";
import { Tab, Tabs } from "vant";
import { NoticeBar } from "vant";
import { Cell, CellGroup } from "vant";
import { Divider } from "vant";
import { Dialog, Toast } from "vant";
Vue.use(Divider);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(NoticeBar);
Vue.use(Tab);
Vue.use(Tabs);
import { getUserInfo,getUserInfo_game } from "@api/user";
import { big_wheel, get_gift } from "@api/game";
import Header from "@components/Header";
import Phaser from "phaser";
let game, vm;
export default {
  name: "Game4",
  components: { Header },
  data() {
    return {
      config: {
        type: Phaser.AUTO,
        width: 800,
        height: 800,
        backgroundColor: "#08080800",
        parent: "game4",
        scale: {
          mode: Phaser.Scale.ScaleModes.FIT
        },
        scene: {
          preload: function() {
            this.load.setBaseURL(VUE_GAME_ASSETS_URL);
            //http://crmeb.test/games/dzp/images/back.png
            this.load.image("bg", "games/dzp/images/back.png");
            this.load.image("wheel", "games/dzp/images/g3.png");
            this.load.image("pin", "games/dzp/images/z - 副本.png");
            // this.load.image("red", "assets/particles/red.png");
          },
          create: function() {
            this.add
              .image(game.config.width / 2, 0, "bg")
              .setOrigin(0.5, 0)
              .setScale(1.6);

            let wheel = this.add
              .image(game.config.width / 2, game.config.width / 2, "wheel")
              .setScale(1.6);

            let pin = this.add
              .image(game.config.width / 2, game.config.width / 2, "pin")
              .setScale(1.2)
              .setInteractive();
            let scene = this;

            // scene.tweens.add({
            //   targets: wheel,
            //   angle: {
            //     from: 0,
            //     to: 45 * 7 + 22
            //   },
            //   duration: 1000
            // });

            pin.on("pointerdown", function() {
              vm.run(wheel, scene);
              // tween.play();
            });
          }
        }
      },
      user_id: 0,
      game_money: 0,
      free_play_times: 0,
      game_log: [],
      useType: 0,
      play_times_today: 0,
      bRotate: false,
      list: [
        { text: "10000金豆", angle: 45 * 5 + 22 },
        { text: "5000金豆", angle: 45 * 3 + 22 },
        { text: "2000金豆", angle: 45 * 2 + 22 },
        { text: "500金豆", angle: 45 * 0 + 22 },
        { text: "100金豆", angle: 45 * 7 + 22 },
        { text: "谢谢参与", angle: 45 * 1 + 22 },
        { text: "谢谢参与", angle: 45 * 4 + 22 }
      ],
      resIndex: 0
    };
  },
  mounted: function() {
    this.user_id=this.getQueryVariable('uid')
    console.log("mounted");
    this.init();
    vm = this;
    game = new Phaser.Game(this.config);
  },
  methods: {
    getQueryVariable(variable)
    {
          var query = window.location.href.substring(window.location.href.indexOf('?')+1);
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
                  var pair = vars[i].split("=");
                  if(pair[0] == variable){return pair[1];}
          }
          return(false);
    },
    init() {
      let that = this;
      // getUserInfo_game(this.user_id).then(res => {
      //   debugger;
        big_wheel({ user_id: that.user_id, page_size: 30 }).then(res => {
          that.game_money = parseFloat(res.data.game_money);
          that.free_play_times = parseInt(res.data.free_play_times);
          that.game_log = res.data.game_log;
          that.play_times_today = res.data.play_times_today;
          if (that.free_play_times > 0) that.useType = 2 - 1;
        });
      // });
    },
    run(wheel, scene) {
      if (10 - vm.play_times_today <= 0) {
        Toast("今天的游戏次数已经用完了");
        return;
      }
      if (vm.useType == 1 - 1 && vm.game_money < 100) {
        Toast("金豆不足");
        return;
      }
      if (vm.useType == 2 - 1 && vm.free_play_times <= 0) {
        Toast("没有优惠券");
        return;
      }

      if (vm.bRotate) return;
      vm.bRotate = true;

      get_gift({ user_id: vm.user_id, type: vm.useType + 1 }).then(res => {
        if (res.status == 200) {
          vm.resIndex = res.data.prize_id - 1;
          let resItem = vm.list[vm.resIndex];
          scene.tweens.add({
            targets: wheel,
            angle: {
              from: 0,
              to: 360 * 5 + resItem.angle
            },
            ease: "Cubic.easeOut",
            duration: 6000,
            // paused: true,
            onComplete: function() {
              Toast(resItem.text);
              vm.init();
              vm.bRotate = false;
            }
          });
          // rotateFn(res.data.prize_id, turnplate.restaraunts[res.data.prize_id-1]);
          // rotateFunc(res.data.prize_id - 1);

          if (vm.useType == 1 - 1) {
            vm.game_money -= 100;
          } else if (vm.useType == 2 - 1) {
            vm.free_play_times--;
            if (vm.free_play_times <= 0) vm.useType = 1 - 1;
          }
        }
      });
    }
  },

  beforeDestroy: function() {
    if (game) {
      game.destroy();
    }
  }
};
</script>
<style scoped>
/* .game {
  background-color: #fa4b42;
} */
</style>
